import { useEventListener } from '@vueuse/core'
import { useLoadingsStore } from '@/stores'
// import { onMounted, onUnmounted } from 'vue'

interface KeyDownParams {
  confirm?: () => void
  close?: () => void
  once?: boolean
}

export function useKeyDown({ confirm, close, once = false }: KeyDownParams) {
  const loadingStore = useLoadingsStore()

  function onKeyBoardEvent(event: KeyboardEvent) {
    const KEYCODE = event.keyCode || event.which
    event.preventDefault()
    if (KEYCODE === 13 && !loadingStore.loading) {
      confirm?.()
      if (once) {
        window.removeEventListener('keyup', onKeyBoardEvent)
      }
    } else if (KEYCODE === 27) {
      close?.()
    }
  }
  useEventListener(window, 'keyup', onKeyBoardEvent)
}
